export default class ObjectInstanceID{
    constructor({ID:id,Type:type}){
        this.ID = id;
        this.Type = type;
    }
    toString(){
        return JSON.stringify(this);
    }
}